import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HelperCard = ({ helper, onChangeHelper }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Selected Helper</h2>
        <Button
          variant="outline"
          size="sm"
          iconName="RefreshCw"
          iconPosition="left"
          onClick={onChangeHelper}
        >
          Change Helper
        </Button>
      </div>
      <div className="flex items-start gap-4">
        <div className="relative">
          <Image
            src={helper?.profileImage}
            alt={helper?.profileImageAlt}
            className="w-20 h-20 rounded-full object-cover"
          />
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full border-2 border-card flex items-center justify-center">
            <Icon name="Check" size={12} className="text-success-foreground" />
          </div>
        </div>

        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-1">{helper?.name}</h3>
          <p className="text-sm text-muted-foreground mb-3">{helper?.title}</p>

          <div className="flex items-center gap-4 mb-3">
            <div className="flex items-center gap-1">
              <Icon name="Star" size={14} className="text-warning fill-warning" />
              <span className="text-sm font-medium text-foreground">{helper?.rating}</span>
              <span className="text-sm text-muted-foreground">({helper?.reviews} reviews)</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Users" size={14} className="text-primary" />
              <span className="text-sm text-muted-foreground">{helper?.sessionsCompleted} sessions</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 mb-3">
            {helper?.specializations?.slice(0, 3)?.map((spec, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-md"
              >
                {spec}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-1">
              <Icon name="Languages" size={14} className="text-muted-foreground" />
              <span className="text-muted-foreground">{helper?.languages?.join(', ')}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="MapPin" size={14} className="text-muted-foreground" />
              <span className="text-muted-foreground">{helper?.location}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-sm text-muted-foreground line-clamp-2">{helper?.bio}</p>
      </div>
    </div>
  );
};

export default HelperCard;